import { ComponentType } from 'react'

const StartPage = () =>
    import('@/pages/start/start-page').then((page) => {
        return page.StartPage as ComponentType
    })

const ArticlePage = () =>
    import('@/pages/article/article-page').then((page) => {
        return page.ArticlePage as ComponentType
    })

//TODO: Fix import
const StatisticsPage = () =>
    import('@/pages/statistic/statistics-page').then((page) => {
        return page.StatisticsPage as ComponentType
    })

const ErrorPage = () =>
    import('@/pages/error/error-page').then((page) => {
        return page.ErrorPage as ComponentType
    })

const SectionStartPage = () =>
    import('@/pages/section-start-page/section-start-page').then((page) => {
        return page.SectionStartPage as ComponentType
    })

const CollectionPage = () =>
    import('@/pages/collection/collection-page').then((page) => {
        return page.CollectionPage as ComponentType
    })

const SearchPage = () =>
    import('@/pages/search/search-page').then((page) => {
        return page.SearchPage as ComponentType
    })

export const pageLookup = (pageTypeName: string): Promise<ComponentType> => {
    switch (pageTypeName) {
        case 'StartPage':
            return StartPage()
        case 'SectionStartPage':
            return SectionStartPage()
        case 'CollectionPage':
            return CollectionPage()
        case 'ArticlePage':
            return ArticlePage()
        case 'StatisticsPage':
            return StatisticsPage()
        // case 'ManualPage':
        //   return ManualPage();
        case 'SearchPage':
            return SearchPage()
        case 'ErrorPage':
            return ErrorPage()

        default:
            return Promise.reject(
                new Error(
                    `Unknown page type name ${pageTypeName}. Cannot load page module.`
                )
            )
    }
}
